module.exports = __webpack_public_path__ + "a8b681f0d388bdcb340e96f43e8d5f55.jpg";